import React from 'react';
import PropTypes from 'prop-types';
import {Banner, Button, Dialogue, Text, Icon} from '@albert-io/atomic';
import HardCapWarningBanner from 'client/components/HardCapWarningBanner/HardCapWarningBanner.react';

import '../invite-by-email.scss';

const IBESummary = ({
  handleClose,
  onBackBtnClick,
  rejectedInvitations,
  hardCapRejectedInvitations,
  fulfilledInvitations,
  ...rest
}) => {
  return (
    <Dialogue handleClose={handleClose} title='Confirmation' {...rest}>
      <Dialogue.Body>
        {fulfilledInvitations.length !== 0 && (
          <div className='u-overflow-y_auto u-pad_2 u-display_flex u-flex-direction_column u-gap_1'>
            {fulfilledInvitations.map((email) => (
              <div className='u-display_flex u-justify-content_space-between u-width_100pc'>
                <Text className='u-text-align_left u-white-space_nowrap u-overflow_hidden u-text-overflow_ellipsis'>
                  {email}
                </Text>
                <div className='ibe-center-padding u-mar-lr_1' />
                <div className='u-display_flex u-align-items_center'>
                  <Text className='u-mar-r_1 u-white-space_nowrap u-color_green-700'>Invited</Text>
                  <Icon icon='check' color='inherit' className='u-color_green-700' />
                </div>
              </div>
            ))}
          </div>
        )}
        {hardCapRejectedInvitations.length !== 0 && (
          <>
            <HardCapWarningBanner seatsRemaining={0} rounded className='u-mar-tb_1' />
            <div className='u-overflow-y_auto u-pad_2 u-display_flex u-flex-direction_column u-gap_1'>
              {hardCapRejectedInvitations.map((email) => (
                <div className='u-display_flex u-justify-content_space-between u-width_100pc'>
                  <Text className='u-text-align_left u-white-space_nowrap u-overflow_hidden u-text-overflow_ellipsis'>
                    {email}
                  </Text>
                  <div className='ibe-center-padding u-mar-lr_1' />
                  <div className='u-display_flex u-align-items_center'>
                    <Text className='u-mar-r_1 u-white-space_nowrap u-color_red-500'>
                      Not invited
                    </Text>
                    <Icon icon='xmark' color='inherit' className='u-color_red-500' />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {rejectedInvitations.length !== 0 && (
          <>
            <Banner theme='danger' className='u-mar-b_2' dismissable={false} border={false}>
              We encountered a problem sending invitations to the following recipients. Please try
              again:
            </Banner>
            <div className='u-overflow-y_auto u-pad_2 u-display_flex u-flex-direction_column u-gap_1'>
              {rejectedInvitations.map((email) => (
                <div className='u-display_flex u-justify-content_space-between u-width_100pc'>
                  <Text className='u-text-align_left u-white-space_nowrap u-overflow_hidden u-text-overflow_ellipsis'>
                    {email}
                  </Text>
                  <div className='ibe-center-padding u-mar-lr_1' />
                  <div className='u-display_flex u-align-items_center'>
                    <Text className='u-mar-r_1 u-white-space_nowrap u-color_red-500'>
                      Not invited
                    </Text>
                    <Icon icon='xmark' color='inherit' className='u-color_red-500' />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </Dialogue.Body>
      <Dialogue.BtnGroup>
        <Button color='secondary' onClick={onBackBtnClick}>
          Back
        </Button>
        <Button onClick={handleClose}>Finish</Button>
      </Dialogue.BtnGroup>
    </Dialogue>
  );
};

IBESummary.propTypes = {
  handleClose: PropTypes.func,
  onBackBtnClick: PropTypes.func,
  rejectedInvitations: PropTypes.arrayOf(PropTypes.string),
  fulfilledInvitations: PropTypes.arrayOf(PropTypes.string),
  hardCapRejectedInvitations: PropTypes.arrayOf(PropTypes.string)
};

export default IBESummary;
